import { render, staticRenderFns } from "./ImgLoader.vue?vue&type=template&id=7567adaf"
import script from "./ImgLoader.vue?vue&type=script&lang=js"
export * from "./ImgLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports